import { Button, CircularProgress, FormControlLabel, Switch, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { notificationRequest } from "../Utils/notifications";

export default function NotificationSettings() {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const mounted = useRef(false);
  const load = useCallback(() => {
    setError("");
    notificationRequest("get_notification_preferences").then((result) => {
      if (mounted.current) { setEnabled(result.emailEnabled); setLoaded(true); }
    }).catch((err) => { if (mounted.current) setError(err.message); });
  }, []);
  useEffect(() => {
    mounted.current = true;
    load();
    return () => { mounted.current = false; };
  }, [load]);
  const save = async (event) => {
    const value = event.target.checked;
    setBusy(true);
    try {
      const result = await notificationRequest("save_notification_preferences", { emailEnabled: value });
      if (mounted.current) { setEnabled(result.emailEnabled); setError(""); }
    } catch (err) { if (mounted.current) setError(err.message); }
    finally { if (mounted.current) setBusy(false); }
  };
  return <>
    <Typography variant="h6">{t("notifications.title")}</Typography>
    {error && <Alert severity="error" action={!loaded ? <Button onClick={load}>{t("notifications.retry")}</Button> : undefined}>{error}</Alert>}
    {((!loaded && !error) || busy) && <CircularProgress size={20} />}
    <FormControlLabel control={<Switch color="primary" checked={enabled} disabled={!loaded || busy} onChange={save} />}
      label={t("notifications.emailEnabled")} />
    <Typography variant="body2" color="textSecondary">{t("notifications.preferenceHelp")}</Typography>
  </>;
}
